import classnames from 'classnames'

export type ScreenStateVariant = 'loading' | 'empty' | 'error' | 'ready'

export interface ScreenStateCardProps {
  title: string
  variant: ScreenStateVariant
  summary: string
  description: string
  meta?: React.ReactNode
  children?: React.ReactNode
}

const variantClassMap: Record<ScreenStateVariant, string> = {
  loading: 'border-sky-200 bg-sky-50 text-sky-900',
  empty: 'border-zinc-200 bg-zinc-50 text-zinc-900',
  error: 'border-rose-200 bg-rose-50 text-rose-900',
  ready: 'border-emerald-200 bg-emerald-50 text-emerald-900'
}

const badgeClassMap: Record<ScreenStateVariant, string> = {
  loading: 'border-sky-300 bg-white text-sky-700',
  empty: 'border-zinc-300 bg-white text-zinc-700',
  error: 'border-rose-300 bg-white text-rose-700',
  ready: 'border-emerald-300 bg-white text-emerald-700'
}

export default function ScreenStateCard({
  title,
  variant,
  summary,
  description,
  meta,
  children
}: ScreenStateCardProps) {
  return (
    <article
      className={classnames(
        'rounded-2xl border p-4 shadow-sm transition-colors',
        variantClassMap[variant]
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] opacity-75">
            Critical Surface
          </p>
          <h3 className="mt-2 text-lg font-semibold">{title}</h3>
        </div>
        <span
          className={classnames(
            'rounded-full border px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.18em]',
            badgeClassMap[variant]
          )}
        >
          {variant}
        </span>
      </div>

      <p className="mt-4 text-sm font-medium">{summary}</p>
      <p className="mt-2 text-sm opacity-80">{description}</p>

      {meta ? <div className="mt-4 text-xs opacity-80">{meta}</div> : null}
      {children ? <div className="mt-4">{children}</div> : null}
    </article>
  )
}
